// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__2ti8G","bigColWidth":"Table_bigColWidth__1zArt","biggerColWidth":"Table_biggerColWidth__25GF9","row":"Table_row__29QtV","col":"Table_col__3ZtH7"};